window.openConfig = function () {
  const cookiesConfig = document.querySelector('#cookies-policy-config')
  const btnConfig = document.querySelector('#btn-config')
  const btnClose = document.querySelector('#btn-close')
  const cookiesInfo = document.querySelector('#cookies-info')

  cookiesConfig.classList.remove('hidden')
  btnConfig.classList.add('hidden')
  cookiesInfo.classList.add('hidden')
  btnClose.classList.remove('hidden')
}

window.cookiesAceptaTodas = function () {
  const cookiesContainer = document.querySelector('#cookies')

  fetch(`/cookies/acepta-todas`, { credentials: 'same-origin' }).then(_ => {
    location.reload()
  })
  cookiesContainer.parentNode.removeChild(cookiesContainer)
}

window.cookiesConfirmaPreferencias = function () {
  const cookiesContainer = document.querySelector('#cookies')

  fetch(`/cookies/confirma-preferencias`, { credentials: 'same-origin' }).then(_ => {
    location.reload()
  })
  cookiesContainer.parentNode.removeChild(cookiesContainer)
}

window.cookiesRechazarTodas = function () {
  fetch(`/cookies/tracking/false`, { credentials: 'same-origin' })
  fetch(`/cookies/banners/false`, { credentials: 'same-origin' }).then(_ => {
    location.reload()
  })
  cookiesContainer.parentNode.removeChild(cookiesContainer)

  //consent mode
  gtag('consent', 'update', {
    functionality_storage: 'granted',
    ad_storage: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500,
    region: ['es-ES']
  })
}

window.toggleTipoCookies = function (tipoCookies) {
  const toggleCheck = document.querySelector(`#checkbox-acepta-${tipoCookies}`)
  const toggleTexto = document.querySelector(`#checkbox-${tipoCookies}-label`)

  fetch(`/cookies/${tipoCookies}/${toggleCheck.checked}`, { credentials: 'same-origin' })
    .then(response => response.text())
    .then(responseText => {
      toggleTexto.innerHTML = responseText
    })
    .catch(function(e) { console.log(e) })
}
